export enum LoginNoticeStatus {
  draft = 0,
  final = 1
}
